module.exports = __webpack_public_path__ + "img/unique-1-xxl.a9477d3.webp";